// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "dd84b85dbc73e2a9596b09e457a7b658" + ".js";
};